import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from './../../../data-storage.service';
import {AvailableComponents} from '../../../side-bar/enumAvailableComponents';
import { SecurityService } from '../../../security.service';
import { ApiTextService } from '../../../apiServices/text/text.service';

@Component({
  selector: 'app-peoplephone-devices-data-base',
  templateUrl: './peoplephone-devices-data-base.component.html',
  styleUrls: ['./peoplephone-devices-data-base.component.scss']
})
export class PeoplephoneDevicesDataBaseComponent implements OnInit, OnDestroy {
  activeTab: string;
  activeTabID: number;
  isDeleted: boolean;

  constructor(public dataStorageService: DataStorageService,
              public securityService: SecurityService,
              private tApi: ApiTextService) {
    this.activeTab = this.dataStorageService.categoriesGlobal[0].name;
    this.activeTabID = this.dataStorageService.categoriesGlobal[0].id;
    this.isDeleted = true;
  }

  tabClick(tab: string, id?: number) {
    this.activeTab = tab;
    this.activeTabID = id;
  }

  ngOnInit() {
    const element = document.getElementById('pfDevices');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['PeoplephoneDevicesDataBase'];
  }

  ngOnDestroy() {
    const element = document.getElementById('pfDevices');
    element.classList.remove('active');
  }

  popupClick() {
    this.dataStorageService.devicePopup = !this.dataStorageService.devicePopup;
  }

  quantityOfDevices(): number {
    let qty = 0;
    this.dataStorageService.currentState.deviceBag.map(e => {
      qty += e.quantity;
    });
    return qty;
  }

  updateText(event, key: string) {
    const value = event.target.value;
    this.tApi.putUIText(key, value);
    this.dataStorageService.setUIText(key, value);
  }

  getDesc() {
    return this.dataStorageService.filterUIText('offer.options.pf-devices.desc');
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplephone-devices-data-base/peoplephone-devices-data-base.component.ts